import type { ModelName } from '@pigello/pigello-matrix';

export function getModelName(contentType: string) {
  const modelName = contentType.split('.').at(1) as ModelName;
  if (!modelName) {
    return undefined;
  }
  return modelName;
}
